import { render, staticRenderFns } from "./LandlordProperties2.vue?vue&type=template&id=607fd6cc&scoped=true&"
import script from "./LandlordProperties2.vue?vue&type=script&lang=js&"
export * from "./LandlordProperties2.vue?vue&type=script&lang=js&"
import style0 from "./LandlordProperties2.vue?vue&type=style&index=0&id=607fd6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fd6cc",
  null
  
)

export default component.exports